import { combineReducers } from '@reduxjs/toolkit'

import featuresReducer from 'redux/slices/Features'
import alertReducer from 'redux/slices/Alert'
import userReducer from 'redux/slices/User'
import siteReducer from 'redux/slices/Site'
import homePageRevisionReducer from 'redux/slices/HomePageRevision'
import filterBuilder from 'redux/slices/FilterBuilder'
import signUpQuestions from 'redux/slices/SignUpQuestions'
import shareReportingDetails from 'redux/slices/ShareReportingDetails'
import hubs from 'redux/slices/Hubs'
import pages from 'redux/slices/Pages'
import participantGroups from 'redux/slices/ParticipantGroups'
import projects from 'redux/slices/Projects'
import projectTags from 'redux/slices/ProjectTags'
import ethnicityReducer from 'redux/slices/Ethnicity'
import genderReducer from 'redux/slices/Gender'
import participantTags from 'redux/slices/ParticipantTags'
import libraraiesDetails from 'redux/slices/Libraries'
import stakeholderDashboardDetails from 'redux/slices/StakeholderDashboard'
import locations from 'redux/slices/Locations'
import filterLocations from 'redux/slices/FilterLocations'
import answers from 'redux/slices/SignupFormAnswers'
import participantProfileSignupFormQuestions from 'redux/slices/ParticipantProfileSignupFormQuestions'
import textAnalysisReducer from 'redux/slices/TextAnalysis'
import toolBuilder from 'redux/slices/ToolBuilder'
import pinnedItems from 'redux/slices/PinnedItems'
import project from 'redux/slices/Project'

const rootReducer = combineReducers({
  features: featuresReducer,
  user: userReducer,
  site: siteReducer,
  homePageRevision: homePageRevisionReducer,
  alert: alertReducer,
  filterBuilder,
  signUpQuestions,
  shareReportingDetails,
  hubs,
  pages,
  participantGroups,
  projects,
  projectTags,
  ethnicity: ethnicityReducer || (() => null),
  gender: genderReducer || (() => null),
  participantTags,
  libraraiesDetails,
  stakeholderDashboardDetails,
  locations,
  filterLocations,
  signupAnswers: answers,
  participantProfileSignupFormQuestions,
  textAnalysis: textAnalysisReducer,
  toolBuilder,
  pinnedItems,
  project,
})

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
